import type { JSX } from 'solid-js';
import { AdminGate } from '../components/AdminGate';
import { AdminOssPanel } from '../components/AdminOssPanel';
import { SESSION_TOKEN } from '../lib/session';

// Admin OSS-verification queue route (#68). Thin: <AdminGate/> keeps the panel
// (its `/v1/admin/oss-verifications` read + `account` MCP verdicts) behind the
// closed-beta staff wall. `token` is injectable for tests; the router mounts
// with no props.

export function AdminOss(props: { token?: string | null } = {}): JSX.Element {
  const token = props.token ?? SESSION_TOKEN;
  return (
    <AdminGate token={token}>
      <AdminOssPanel token={token} />
    </AdminGate>
  );
}
